module.exports = {"attributes":{"viewBox":"0 0 200 200","xmlns":"http://www.w3.org/2000/svg"},"content":"<polygon points=\"98.578 123.534 158.832 99.315 158.832 147.705 98.578 171.926 38.326 196.095 38.326 147.705\" style=\"fill: #e82326\"> \t</polygon> \t<polygon points=\"38.326 50.925 158.832 2.535 158.832 50.925 38.326 99.315\" style=\"fill: rgb(56, 75, 171);\"> \t</polygon> \t<polygon points=\"148.683 95.238 88.372 119.458 48.474 103.394 108.785 79.173\" style=\"fill: #fadd4a\"> \t</polygon>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/channel/streamer.svg
// module id = 1356
// module chunks = 0